import { ThemeProvider } from 'next-themes';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Toaster } from 'sonner';
import KeycloakApp from './app.tsx';
import './index.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <ThemeProvider
      attribute="class"
      defaultTheme="light"
      enableSystem={false}
      storageKey="steerfi-theme"
    >
      <KeycloakApp />
      <Toaster position="top-right" richColors />
    </ThemeProvider>
  </React.StrictMode>
);
